import { Injectable } from '@angular/core';
import { Operation } from '../models/operation';

@Injectable({
  providedIn: 'root',
})
export class OperationRepo {
  op: Operation;

  async setOperation(op: Operation) {
    console.log('guarando la op', op);

    this.op = op;
    await localStorage.setItem('operation', JSON.stringify(op));
  }

  async loadOperation() {
    const ret = await localStorage.getItem('operation');
    if (ret) {
      const user = JSON.parse(ret);
      this.op = new Operation(user);
      return this.op;
    }
    return null;
  }

  async removeOperation() {
    await localStorage.removeItem('operation');
  }

  async clear() {
    this.op = null;
    await localStorage.clear();
  }

  public getOperation() {
    return this.op;
  }
}
